import { gql } from "@apollo/client";

export const APPLY_WORKFLOW_MUTATION = gql`
  mutation ApplyWorkflowInstanceDataChanges($input: json!, $metadata: json!) {
    apply_workflow_instance_data_changes(data: $input, metadata: $metadata)
  }
`;
